import globalConfig from "../assets/assets/globalConfig";

export const DRIVE_API_KEY = globalConfig.googleDriveApiKEY;
export const BASE_URL = globalConfig.baseUrl;
export const NEW_BASE_URL = globalConfig.newBaseUrl;
export const IDENTITY_END_SESSION_URL = globalConfig.identityEndSessionUrl;
export const FRONTEND_URL = globalConfig.frontEndUrl;
export const reCAPTCHA_KEY = globalConfig.reCaptchaKey;
export const REACT_HEADER_CLIENT_ID = globalConfig.reactHeaderClientId;
export const NEW_APPLICATION_CLIENT_ID = globalConfig.newApplicationClientId;

export const OAUTH_REDIRECT_URL =
  window.location.protocol +
  "//" +
  window.location.host +
  FRONTEND_URL +
  "oauth2/callback";

export const GOOGLE_ANALYTICS_PROPERTY_ID =
  globalConfig.googleAnalyticsPropertyId;

export const RELATIVE_JSON_API_LINKS = globalConfig.relativeJsonApiLinks;

export const FRONTEND_ORIGIN_URL =
  window.location.protocol + "//" + window.location.host + FRONTEND_URL;

export const FRONTEND_ORIGIN_URL_NO_SLASH =
  window.location.protocol +
  "//" +
  window.location.host +
  FRONTEND_URL.slice(0, -1);

export const TEMP_CLIENT_ID = "516C6E55-8071-460A-BF1E-9B9F58F3A21C";

export const SLACK_URL =
  "https://join.slack.com/t/nbgtechnology/shared_invite/enQtNTE5OTk0MDQ5MzMzLWQ3YmUzYjQwNGE2NThlYTkwYzQxMTlkODEzNjdhMWY3NDVkMWViYWUxZjQ2ZjAwMWZmOThkZGNjZWNjNDc1ZTY";

export const DEFAULT_PAGINATION = 50;

// Basic Page IDs
export const BASIC_PAGE_IDS = {
  TERMS_AND_CONDITIONS: "92a32357-f31e-4788-9e58-5456610ef113",
  PRIVACY_POLICY: "abbd2afa-5b7f-43a6-a525-88da5e4e1fdf",
  OAUTH_DOCUMENT: "cde21bab-100e-419e-9615-f531cb23f4f1",
};
